export default async function useVacancyUserContext(
  vacancyInput: Ref<Vacancy | undefined> | Vacancy,
) {
  // Normalize the vacancy input to always be a reactive reference
  const vacancy = ref(unref(vacancyInput))

  const { currentUser } = storeToRefs(useCurrentUserStore())
  const { currentOrganization } = storeToRefs(useCurrentOrganizationStore())
  const { isAdmin, isCenterAdmin } = useCurrentOrganizationRoles()
  // console.log('useVacancyUserContext', vacancy.value, currentUser.value)

  // Is the user the creator of the vacancy?
  // This also includes volunteers who created a (p2p) vacancy
  const isVacancyCreator = computed(() => {
    if (!currentUser.value) return false
    return vacancy.value?.createdByUserId == currentUser.value.id
  })

  // Is the user an admin of the organization that owns the vacancy?
  const isAdminOfVacancyOrganization = computed(() => {
    if (!currentUser.value) return false
    return (
      isAdmin.value
      && currentOrganization.value.id === vacancy.value?.organizationId
    )
  })

  // The name is a bit misleading, because we mean "an admin of a primary center"
  const isPrimaryManager = computed(() => {
    if (!currentUser.value) return false
    return (
      isCenterAdmin.value
      && currentOrganization.value.id === vacancy.value?.organizationManagedById
    )
  })

  const isSecondaryManager = computed(() => {
    if (!currentUser.value) return false
    if (isPrimaryManager.value || isVacancyCreator.value) return false
    return (
      isCenterAdmin.value
      && !!vacancy.value?.volunteerCenterIds?.find(
        id => id === currentOrganization.value.id,
      )
    )
  })

  const canManageVacancy = computed(
    () =>
      isVacancyCreator.value
      || isPrimaryManager.value
      || isAdminOfVacancyOrganization.value
      || isSecondaryManager.value,
  )

  // console.log({
  //   isVacancyCreator: isVacancyCreator.value,
  //   isAdminOfVacancyOrganization: isAdminOfVacancyOrganization.value,
  //   isPrimaryManager: isPrimaryManager.value,
  //   isSecondaryManager: isSecondaryManager.value,
  //   canManageVacancy: canManageVacancy.value,
  // })

  return {
    isVacancyCreator,
    isAdminOfVacancyOrganization,
    isPrimaryManager,
    isSecondaryManager,
    canManageVacancy,
  }
}
